export default __webpack_public_path__ + "static/media/sgd-3.519537a4.png";